import React from 'react'
import ManageProductsComponent from './ManageProductsComponent/ManageProductsComponent'
import Page from "../../Page/Page";

const ManageProducts = () => {
    return (
        <Page>
            <ManageProductsComponent />
        </Page>
    )
}

export default ManageProducts
